export default __webpack_public_path__ + "static/media/upsellupgrade.7410b135.svg";